import * as types from './../mutation-types.js'
import navitems from './../nav-items.js'

// states
const state = {
  sidebarIsActive: false,
  sidebarComponent: null,
  navitems
}

//getters
const getters = {
  sidebarIsActive: state => {state.sidebarIsActive;},
  sidebarComponent: state => state.sidebarComponent,
  navitems: state => state.navitems
}

//actions
const actions = {
  toggleSidebar ({ commit, state }, {component}) {
    commit(types.TOGGLE_SIDEBAR)

    // This is new! We're using one action to trigger two mutations!
    commit(types.SET_SIDEBAR_COMPONENT, component)
  },
  setSidebarState ({ commit, state }, {isActive}) {
    commit(types.SET_SIDEBAR_STATE, isActive)
  }
}

//mutations
const mutations = {
  [types.TOGGLE_SIDEBAR](state) {
    state.sidebarIsActive = !state.sidebarIsActive
  },
  [types.SET_SIDEBAR_STATE](state, isActive) {
    state.sidebarIsActive = isActive
  },

  // When toggleSidebar action is called, this mutation is triggered
  // storing the passed in component in our application state
  [types.SET_SIDEBAR_COMPONENT](state, component) {
    state.sidebarComponent = component
  }
}


// ------ export module -------
const navigation = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

export default navigation;



// WEBPACK FOOTER //
// ./src/store/modules/navigation.js